import { css } from '@emotion/react';
import { Suspense } from 'react';
import { Outlet } from 'react-router-dom';

import Loader from '~/common/components/utils/Loader';
import useScrollReset from '~/common/hooks/useScrollReset';
import Footer from '~/common/layouts/Footer.tsx';
import NavigationBar from '~/common/layouts/NavigationBar.tsx';
import { useAppSelector } from '~/common/stores';
import SectionDownload from '~/features/home/components/SectionDownload';

function BaseLayout() {
  useScrollReset();
  const isLoading = useAppSelector(state => state.layout.isLoading);

  return (
    <div css={styles.layoutMain}>
      <NavigationBar />

      <main>
        <Suspense fallback={null}>
          <Outlet />
        </Suspense>
      </main>

      <SectionDownload />
      <Footer />

      {isLoading && <Loader fullScreen />}
    </div>
  );
}

const styles = {
  layoutMain: css`
    display: flex;
    flex-direction: column;
    min-height: 100vh;
    background: #0b0714;

    main {
      flex: 1;
      min-height: 60vh;
    }
  `,
};

export default BaseLayout;
